export default {
  US: {
    image: '../../../../assets/images/countryUS.png',
    name: 'United States - Company 130',
  },
  CA: {
    image: '../../../../assets/images/countryCA.png',
    name: 'Canada - Company 100',
  },
  GB: {
    image: '../../../../assets/images/countryGB.png',
    name: 'United Kingdom - Company 387',
  },
  DE: {
    image: '../../../../assets/images/countryDE.png',
    name: 'Germany - Company 244',
  },
  AU: {
    image: '../../../../assets/images/countryAU.png',
    name: 'Australia - Company 408',
  },
  BE: {
    image: '../../../../assets/images/countryBE.png',
    name: 'Belgium',
  },
  NL: {
    image: '../../../../assets/images/countryNL.png',
    name: 'Netherlands',
  },
  NS: {
    image: '../../../../assets/images/countryNS.png',
    name: 'Norbar & Sturtevant - Company 138',
  },
};
